import { Auth } from '../models/Auth';
import { getUserScopedStorageKeys } from '../storage/UserScopedStorageKeys';

class AuthDAO {
  static getAuth(): Auth | null {
    let authStr = localStorage.getItem((getUserScopedStorageKeys()).AUTH_KEY);
    return authStr ? JSON.parse(authStr) : null;
  }

  static setAuth(auth: Auth): void {
    localStorage.setItem((getUserScopedStorageKeys()).AUTH_KEY, JSON.stringify(auth));
  }

  static clear(): void {
      localStorage.removeItem((getUserScopedStorageKeys()).AUTH_KEY);
  }
}

export default AuthDAO;